


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import { Container } from 'inversify';
import TimeLineTypeConst from '../../../../domain/Constants/TimeLineTypeConst';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import ControlTypeConst from '../../../../domain/Constants/ControlTypeConst';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';	

export default defineComponent({

    name: 'dynamic_time_line',
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:

        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        }, 
    },
    setup(props, context) {
        //
        
        const store = useStore();
        const { vmodel, loaded, resolveExpressions, getPropertyValue, getPropertyBooleanValue, getPropertyNumberValue, getCatalogValue, 
            baseOnUnmount,fieldKey,fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);



        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }




        onMounted(() => {

        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            TimeLineTypeConst,
            getPropertyNumberValue,
            loaded,
            BaseControlTypeConst,
            ControlTypeConst,
            getCatalogValue,
            fieldKey,
            fieldKeyComponentDataSourceId
        };
    },
});
